import * as React from 'react';
import { useState, useEffect, useRef} from "react";
import {useSelector} from 'react-redux';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ConfigurationViewService from '../services/configurationview.service';

const options = ['Dashboard1', 'Dashboard2', 'Dashboard3'];

export default function SplitButton2({projectName, dashboardType, selectedDashboard} ) {
  //console.log(dashboardType)
  const { user } = useSelector((state) => state.auth);
  
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [dashboardList, setDashboardList] = useState([]);
  const [dashboard, setDashboard] = useState();


  useEffect(() => {
      async function loadDashboards() {
          try {
              // ------------------------------------------------
              // Get all dashboard names
              // ------------------------------------------------
              const dashboardResponse = await ConfigurationViewService.getDashboardList( projectName, dashboardType );
              const allDashboardList = Array.isArray(dashboardResponse?.data) ? dashboardResponse.data : [];
              //console.log( "All Dashboard List:", allDashboardList );

              // ------------------------------------------------
              // SUPERADMIN / ENGINEER
              // Show ALL dashboards without group filtering
              // ------------------------------------------------
              const isSuperAdminOrEngineer = user?.role === "superadmin" || user?.role === "engineer";
              if (isSuperAdminOrEngineer) {
                  let finalDashboardList = allDashboardList.slice().sort();
                  setDashboardList( finalDashboardList );
                  if ( finalDashboardList.length > 0 ) {
                      setSelectedIndex(0);
                      selectedDashboard( finalDashboardList[0] );

                  } else {
                      setSelectedIndex(0);
                      selectedDashboard( undefined );
                  }

                  return;
              }

              // ------------------------------------------------
              // NORMAL USERS
              // Get dashboard/group configuration
              // ------------------------------------------------
              const dashboardConfigResponse = await ConfigurationViewService.getColumnData( "Dashboard", "projectname",  projectName );
              const dashboardConfigList = Array.isArray( dashboardConfigResponse?.data ) ? dashboardConfigResponse.data : [];
              //console.log( "Dashboard Configuration:", dashboardConfigList );

              // ------------------------------------------------
              // User's assigned groups
              // ------------------------------------------------
              const userGroupNameList = Array.isArray( user?.groupnamelist ) ? user.groupnamelist : [];
              //console.log( "User Group List:",  userGroupNameList );

              // ------------------------------------------------
              // Filter dashboards based on groups
              // ------------------------------------------------
              const filteredDashboardList =
                  allDashboardList.filter(
                      (dashboardName) => {
                          const dashboardConfig = dashboardConfigList.find( (item) => item?.dashboardname ===  dashboardName && item?.dashboardtype === dashboardType
                              );

                          if (!dashboardConfig) {  return false; }
                          const dashboardGroupNameList = Array.isArray( dashboardConfig.groupnamelist ) ? dashboardConfig.groupnamelist : [];
                          // At least one group must match
                          return dashboardGroupNameList.some( (dashboardGroup) => userGroupNameList.includes( dashboardGroup ) ); } );

              // ------------------------------------------------
              // Remove UsersConfig1 for normal users
              // ------------------------------------------------
              const finalDashboardList = filteredDashboardList .filter( (item) => item !== "UsersConfig1" ) .slice() .sort();
              //console.log( "Filtered Dashboard List:", finalDashboardList );

              // ------------------------------------------------
              // Set dashboard list
              // ------------------------------------------------
              setDashboardList( finalDashboardList );

              // ------------------------------------------------
              // Select first dashboard
              // ------------------------------------------------
              if ( finalDashboardList.length > 0 ) {
                  setSelectedIndex(0);
                  selectedDashboard( finalDashboardList[0] );

              } else {
                  setSelectedIndex(0);
                  selectedDashboard( undefined );
              }


          } catch (error) {
              console.error( "Error loading dashboards:", error );
              setDashboardList([]);
              setSelectedIndex(0);
              selectedDashboard( undefined );
          }
      }

      if ( projectName && dashboardType && user ) { loadDashboards(); }

  }, [  projectName, dashboardType, user ]);

  const handleClick = () => {
    //console.log("button Clicked")
    //console.info(`You clicked ${dashboardList[selectedIndex]}`);
    setDashboard(dashboardList[selectedIndex]);
    
    
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
    //console.log(dashboardList, dashboardList[index])
    selectedDashboard(dashboardList[index]);
    handleClick();
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
        <Button onClick={handleToggle}>{dashboardList[selectedIndex]}</Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 10,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {dashboardList.map((option, index) => (
                    <MenuItem
                      key={option}
                      //disabled={index === 3}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}
